import { ReactNode, FC } from "react";

import styles from "./template2.module.css";

export const Template2: FC<{ children: ReactNode }> = ({ children }) => {
  return <div className={styles.templateContainer}>{children}</div>;
};
